export const plasmaSaleAbi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "init",
                type: "tuple",
                internalType: "struct PlasmaSale.Init",
                components: [
                    {
                        name: "saleUUID",
                        type: "bytes16",
                        internalType: "bytes16",
                    },
                    {
                        name: "admin",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "settler",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "pauser",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "purchasePermitSigner",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "tokens",
                        type: "address[]",
                        internalType: "contract IERC20[]",
                    },
                    {
                        name: "totalAllocation",
                        type: "uint256",
                        internalType: "Fixed6",
                    },
                ],
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "DEFAULT_ADMIN_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "PAUSER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "PURCHASE_PERMIT_SIGNER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "REFUNDER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "RESERVED_AMOUNT_RESETTER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "SETTLER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "TOKEN_RECOVERER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "balanceByAddress",
        inputs: [
            {
                name: "wallet",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "Fixed6",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "balanceByAddressAndToken",
        inputs: [
            {
                name: "wallet",
                type: "address",
                internalType: "address",
            },
            {
                name: "token",
                type: "address",
                internalType: "contract IERC20",
            },
        ],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "Fixed6",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "closeFunding",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "commitWithApproval",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "contract IERC20",
            },
            {
                name: "tokenAmount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "purchasePermit",
                type: "tuple",
                internalType: "struct PurchasePermitWithAllocationFixed6",
                components: [
                    {
                        name: "permit",
                        type: "tuple",
                        internalType: "struct PurchasePermit",
                        components: [
                            {
                                name: "entityID",
                                type: "bytes16",
                                internalType: "bytes16",
                            },
                            {
                                name: "saleUUID",
                                type: "bytes16",
                                internalType: "bytes16",
                            },
                            {
                                name: "wallet",
                                type: "address",
                                internalType: "address",
                            },
                            {
                                name: "expiresAt",
                                type: "uint64",
                                internalType: "uint64",
                            },
                            {
                                name: "payload",
                                type: "bytes",
                                internalType: "bytes",
                            },
                        ],
                    },
                    {
                        name: "reservedAmount",
                        type: "uint256",
                        internalType: "Fixed6",
                    },
                    {
                        name: "maxAmount",
                        type: "uint256",
                        internalType: "Fixed6",
                    },
                ],
            },
            {
                name: "purchasePermitSignature",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "commitWithPermit",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "contract IERC20",
            },
            {
                name: "tokenAmount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "erc20PermitDeadline",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "erc20PermitSignature",
                type: "bytes",
                internalType: "bytes",
            },
            {
                name: "purchasePermit",
                type: "tuple",
                internalType: "struct PurchasePermitWithAllocationFixed6",
                components: [
                    {
                        name: "permit",
                        type: "tuple",
                        internalType: "struct PurchasePermit",
                        components: [
                            {
                                name: "entityID",
                                type: "bytes16",
                                internalType: "bytes16",
                            },
                            {
                                name: "saleUUID",
                                type: "bytes16",
                                internalType: "bytes16",
                            },
                            {
                                name: "wallet",
                                type: "address",
                                internalType: "address",
                            },
                            {
                                name: "expiresAt",
                                type: "uint64",
                                internalType: "uint64",
                            },
                            {
                                name: "payload",
                                type: "bytes",
                                internalType: "bytes",
                            },
                        ],
                    },
                    {
                        name: "reservedAmount",
                        type: "uint256",
                        internalType: "Fixed6",
                    },
                    {
                        name: "maxAmount",
                        type: "uint256",
                        internalType: "Fixed6",
                    },
                ],
            },
            {
                name: "purchasePermitSignature",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "committerAt",
        inputs: [
            {
                name: "index",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "committers",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address[]",
                internalType: "address[]",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "disableFunding",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "finalizeSettlement",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "fundingEnabled",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getRoleAdmin",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getRoleMember",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "index",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getRoleMemberCount",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getRoleMembers",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [
            {
                name: "",
                type: "address[]",
                internalType: "address[]",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "grantRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "hasRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "numCommitters",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "numSettled",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "readUserState",
        inputs: [
            {
                name: "committer",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple",
                internalType: "struct PlasmaSale.UserStateView",
                components: [
                    {
                        name: "entityID",
                        type: "bytes16",
                        internalType: "bytes16",
                    },
                    {
                        name: "settled",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "reservedAmount",
                        type: "uint256",
                        internalType: "Fixed6",
                    },
                    {
                        name: "totalBalance",
                        type: "uint256",
                        internalType: "Fixed6",
                    },
                    {
                        name: "balanceByToken",
                        type: "uint256[]",
                        internalType: "Fixed6[]",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "readUserStates",
        inputs: [
            {
                name: "committers_",
                type: "address[]",
                internalType: "address[]",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple[]",
                internalType: "struct PlasmaSale.UserStateView[]",
                components: [
                    {
                        name: "entityID",
                        type: "bytes16",
                        internalType: "bytes16",
                    },
                    {
                        name: "settled",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "reservedAmount",
                        type: "uint256",
                        internalType: "Fixed6",
                    },
                    {
                        name: "totalBalance",
                        type: "uint256",
                        internalType: "Fixed6",
                    },
                    {
                        name: "balanceByToken",
                        type: "uint256[]",
                        internalType: "Fixed6[]",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "recoverTokens",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "contract IERC20",
            },
            {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "refund",
        inputs: [
            {
                name: "committer",
                type: "address",
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                internalType: "Fixed6",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "renounceRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "callerConfirmation",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "resetReservedAmount",
        inputs: [
            {
                name: "committer",
                type: "address",
                internalType: "address",
            },
            {
                name: "newReservedAmount",
                type: "uint256",
                internalType: "Fixed6",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "revokeRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "saleUUID",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "setFundingEnabled",
        inputs: [
            {
                name: "enabled",
                type: "bool",
                internalType: "bool",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setStage",
        inputs: [
            {
                name: "stage_",
                type: "uint8",
                internalType: "enum PlasmaSale.Stage",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "settle",
        inputs: [
            {
                name: "committer",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "settleBatch",
        inputs: [
            {
                name: "committers_",
                type: "address[]",
                internalType: "address[]",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "stage",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint8",
                internalType: "enum PlasmaSale.Stage",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "supportsInterface",
        inputs: [
            {
                name: "interfaceId",
                type: "bytes4",
                internalType: "bytes4",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "tokenConfigs",
        inputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IERC20",
            },
        ],
        outputs: [
            {
                name: "allowed",
                type: "bool",
                internalType: "bool",
            },
            {
                name: "decimals",
                type: "uint8",
                internalType: "uint8",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "totalAllocation",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "Fixed6",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "totalBalance",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "Fixed6",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "totalExcessGranted",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "Fixed6",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "totalReservedUsed",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "Fixed6",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "withdraw",
        inputs: [
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "event",
        name: "RoleAdminChanged",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "previousAdminRole",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "newAdminRole",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoleGranted",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "sender",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoleRevoked",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "sender",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "error",
        name: "AccessControlBadConfirmation",
        inputs: [],
    },
    {
        type: "error",
        name: "AccessControlUnauthorizedAccount",
        inputs: [
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
            {
                name: "neededRole",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
    },
    {
        type: "error",
        name: "AlreadySettled",
        inputs: [
            {
                name: "committer",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "ECDSAInvalidSignature",
        inputs: [],
    },
    {
        type: "error",
        name: "ECDSAInvalidSignatureLength",
        inputs: [
            {
                name: "length",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "ECDSAInvalidSignatureS",
        inputs: [
            {
                name: "s",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
    },
    {
        type: "error",
        name: "InvalidSaleUUID",
        inputs: [
            {
                name: "got",
                type: "bytes16",
                internalType: "bytes16",
            },
            {
                name: "want",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
    },
    {
        type: "error",
        name: "InvalidSender",
        inputs: [
            {
                name: "got",
                type: "address",
                internalType: "address",
            },
            {
                name: "want",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "InvalidStage",
        inputs: [
            {
                name: "got",
                type: "uint8",
                internalType: "enum PlasmaSale.Stage",
            },
            {
                name: "want",
                type: "uint8",
                internalType: "enum PlasmaSale.Stage",
            },
        ],
    },
    {
        type: "error",
        name: "InvalidToken",
        inputs: [
            {
                name: "got",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "InvalidTokenDecimals",
        inputs: [
            {
                name: "tokenDecimals",
                type: "uint8",
                internalType: "uint8",
            },
        ],
    },
    {
        type: "error",
        name: "InvalidTokenDecimals",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "contract IERC20",
            },
            {
                name: "got",
                type: "uint8",
                internalType: "uint8",
            },
        ],
    },
    {
        type: "error",
        name: "MethodDisabled",
        inputs: [],
    },
    {
        type: "error",
        name: "NotAllSettlementsCompleted",
        inputs: [
            {
                name: "numSettled",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "numCommitters",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "NotCommitter",
        inputs: [
            {
                name: "wallet",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "PurchasePermitExpired",
        inputs: [],
    },
    {
        type: "error",
        name: "RefundedAmountExceedsFundedAmount",
        inputs: [
            {
                name: "committer",
                type: "address",
                internalType: "address",
            },
            {
                name: "refundAmount",
                type: "uint256",
                internalType: "Fixed6",
            },
            {
                name: "fundedAmount",
                type: "uint256",
                internalType: "Fixed6",
            },
        ],
    },
    {
        type: "error",
        name: "SafeERC20FailedOperation",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "TokenAmountConversionLossOfPrecision",
        inputs: [
            {
                name: "tokenAmount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "tokenDecimals",
                type: "uint8",
                internalType: "uint8",
            },
            {
                name: "remainder",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "TotalUsedReservedAmountExceedsTotalAllocation",
        inputs: [
            {
                name: "totalUsedReservedAmount",
                type: "uint256",
                internalType: "Fixed6",
            },
            {
                name: "totalAllocation",
                type: "uint256",
                internalType: "Fixed6",
            },
        ],
    },
    {
        type: "error",
        name: "UnauthorizedSigner",
        inputs: [
            {
                name: "signer",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "WalletAlreadyUsedByAnotherEntity",
        inputs: [
            {
                name: "wallet",
                type: "address",
                internalType: "address",
            },
            {
                name: "existingEntityID",
                type: "bytes16",
                internalType: "bytes16",
            },
            {
                name: "newEntityID",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
    },
    {
        type: "error",
        name: "ZeroAmount",
        inputs: [],
    },
] as const;
